/* tslint:disable */

declare var Object: any;
export interface StoragePartnerInterface {
  "id"?: number;
}

export class StoragePartner implements StoragePartnerInterface {
  "id": number;
  constructor(data?: StoragePartnerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StoragePartner`.
   */
  public static getModelName() {
    return "StoragePartner";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StoragePartner for dynamic purposes.
  **/
  public static factory(data: StoragePartnerInterface): StoragePartner{
    return new StoragePartner(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StoragePartner',
      plural: 'StoragePartners',
      path: 'StoragePartners',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StoragePartner.ts